/* eslint-disable jsx-a11y/label-has-for, react/style-prop-object */
import React from 'react';
import PropTypes from 'prop-types';
import NumericInput from 'react-numeric-input';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './NumericInput.scss';

const NumberInput = ({
  value,
  onChange,
  label,
  showLabel,
  fluid,
  placeholder,
  name,
  minNumber,
  ...props
}) => {
  const labelClass = cx(showLabel ? s.label : 'visually-hidden');
  return (
    <label className={cx(s.root, fluid && s.fluid)}>
      <span className={labelClass}>{label}</span>
      <NumericInput
        style={false}
        min={minNumber}
        value={value}
        onChange={valueAsNumber =>
          onChange({ target: { value: valueAsNumber } })
        }
        mobile={false}
        {...props}
      />
    </label>
  );
};

NumberInput.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  showLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  fluid: PropTypes.bool,
  minNumber: PropTypes.number,
};

NumberInput.defaultProps = {
  fluid: false,
  label: '',
  showLabel: false,
  placeholder: '',
  minNumber: 1,
};

export default withStyles(s)(NumberInput);
